import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
const API = `${BACKEND_URL}/api`;

const LogoutButton = () => {
    const { logout, user } = useAuth();
    const [currentTime, setCurrentTime] = useState(null);

    // Update time in real-time for the header
    useEffect(() => {
        let isMounted = true;

        const updateTime = async () => {
            try {
                const response = await axios.get(`${API}/timezone/current?timezone_name=Europe/Paris`);
                if (isMounted) {
                    setCurrentTime(response.data);
                }
            } catch (error) {
                const now = new Date();
                if (isMounted) {
                    setCurrentTime({
                        formatted: now.toLocaleString('en-US', {
                            weekday: 'long',
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            timeZone: 'Europe/Paris'
                        }).replace(/^./, str => str.toUpperCase())
                    });
                }
            }
        };

        updateTime();
        const timeInterval = setInterval(updateTime, 30000);

        return () => {
            isMounted = false;   // prevent state updates after unmount
            clearInterval(timeInterval);
        };
    }, []);


    const handleLogout = () => {
        logout();
    };

    return (
        <div className="flex items-center space-x-6">
            {/* Live time - TO THE LEFT of "Connected as" */}
            <div className="flex items-center text-sm text-blue-600 font-medium">
                <span className="w-2 h-2 bg-green-400 rounded-full mr-2 animate-pulse"></span>
                🕐 {currentTime ? currentTime.formatted : 'Loading...'}
            </div>

            {/* User information */}
            <span className="text-sm text-gray-600">
                Connected as {user?.name}
            </span>

            {/* Logout button */}
            <button
                onClick={handleLogout}
                className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-sm"
            >
                Logout
            </button>
        </div>
    );
};

export default LogoutButton;